export default __webpack_public_path__ + "static/media/nantes9.00fed3c5.jpg";